<div style="padding: 25px">
    <h1 mat-dialog-title>{{ 'CASHIERMANAGEMENT.transfer_of_cashier' | translate }}</h1>
    <div mat-dialog-content>
        <p>
            Selecione o outro caixa para quem deseja enviar, levando em consideração que o mesmo usuário deve ser caixa
            e não ter nenhum caixa em aberto.
        </p>
        <mat-form-field class="full-width" appearance="fill" [floatLabel]="'auto'">
            <mat-label>{{ 'CASHIERMANAGEMENT.cashier' | translate }}</mat-label>
            <input
                type="text"
                placeholder="Digite e selecione um caixa"
                aria-label="Cashier"
                matInput
                [formControl]="cashierControl"
                [matAutocomplete]="cashierAuto" />
            <mat-autocomplete autoActiveFirstOption #cashierAuto="matAutocomplete" [displayWith]="displayCashierFn">
                <mat-option *ngFor="let cashier of filteredCashiers | async" [value]="cashier">
                    {{ cashier.cashierName }}
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <div mat-dialog-actions>
        <button mat-raised-button (click)="onCancelTransfer()" [disabled]="_loaderService.isLoading | async">
            {{ 'CASHIERMANAGEMENT.cancel' | translate }}
        </button>
        <button
            mat-raised-button
            color="primary"
            (click)="onTransfer()"
            [disabled]="(_loaderService.isLoading | async) || !cashierControl.valid">
            {{ 'CASHIERMANAGEMENT.transfer' | translate }}
        </button>
    </div>
</div>
